export const getFullName = (humanName) => {
    const givenNames = Array.isArray(humanName?.given)
      ? humanName.given.join(' ').trim()
      : '';
  
    const familyName = humanName?.family ?? '';
  
    return [givenNames, familyName].filter(Boolean).join(' ');
}

export const getFullNameLastNameFirst = (humanName) => {
    const givenNames = Array.isArray(humanName?.given)
      ? humanName.given.filter(Boolean).join(' ').trim()
      : '';
    const familyName = String(humanName?.family || '').trim();

    if (familyName && givenNames) {
      return `${familyName}, ${givenNames}`;
    }

    return familyName || givenNames;
}

 export const getAgeFromDOB = (dobString) => {
    const dob = new Date(dobString);
    const today = new Date();
  
    let age = today.getFullYear() - dob.getFullYear();
    const hasBirthdayPassedThisYear =
      today.getMonth() > dob.getMonth() ||
      (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());
  
    if (!hasBirthdayPassedThisYear) {
      age -= 1;
    }
  
    return age;
}

export  const getSpecialtiesCommaSeparated = (practitionerRole = []) => {
    return practitionerRole
      .map(role => role?.specialty?.text)
      .filter(Boolean) // remove undefined/null
      .join(', ');
}

